<script>
	import { onMount, tick } from "svelte";
	import Slide from "./Slide.svelte";
	import Tabs from "./Tabs.svelte";
	import SelectDomain from "./Select.svelte";
	import ChoosePlan from "./Choose.svelte";
	import User from "./User/User.svelte";
	import { fly } from "svelte/transition";
	import Modali from "./User/Modali.svelte";
	// import objectStore from "./../store.js";

	// import Login from "./User/Login.svelte";
	export let langCode = "en";
	export let domain;
	export let sub;
	export let token;

	let showModal = false;

	// function handleBackModali() {
	// 	showModal = false;
	// }
	// const api = "https://localhost:44311/";
	// const api = "https://localhost:44354/";
	const api = "/";

	let ready = false;
	let domainAvailable = false;
	let tabVal = 0;
	let register = false;
	let search = null;
	let plans = false;
	let back = false;

	let user = false;
	let preuser = null;
	if (domain & sub) {
	}

	$: curtab = tabVal;

	const tabs = [];
	const labels = [
		{ lang: "en", l1: "Search", l2: "Plans" },
		{ lang: "es", l1: "Select", l2: "Choose" },
		{ lang: "pt", l1: "Select", l2: "Choose" },
		{ lang: "ar", l1: "Select", l2: "Choose" },
		{ lang: "nl", l1: "Select", l2: "Choose" },
		{ lang: "fr", l1: "Select", l2: "Choose" },
		{ lang: "it", l1: "Select", l2: "Choose" },
		{ lang: "ru", l1: "Select", l2: "Choose" },
		{ lang: "de", l1: "Select", l2: "Choose" },
		{ lang: "zh", l1: "Select", l2: "Choose" },
		{ lang: "jp", l1: "Select", l2: "Choose" },
	];

	onMount(() => {
		setLabels();
		ready = true;
		console.log(domainAvailable);
	});

	function planSet() {
		register = true;
		preuser = false;
		user = true;
		showModal = true; // <--- agrega esto
	}
	function domainChecked(e) {
		console.log(e.detail);
		if (e.detail.available) {
			domain = e.detail.domain;
			sub = e.detail.sub;

			setTimeout(() => {
				tabVal = 1;
				search = false;
				plans = true;
				domainAvailable = true;
			}, 500);
		}
	}
	async function handleBack() {
		console.log("go back");
		register = false;
		preuser = true;
		user = false;
		plans = null;
		back = true;
		await tick();
		back = false;
		await new Promise((r) => setTimeout(r, 300));
		showModal = false;
	}

	function setLabels() {
		const translations = labels.filter((x) => x.lang == langCode);

		if (translations.length == 0) {
			labels.filter((x) => x.lang == "en");
		}

		tabs.push({ label: translations[0].l1, name: "d" });
		tabs.push({ label: translations[0].l2, name: "d" });
	}

	async function tabChange(event) {
		console.log("tab change");
		console.log(event.detail.text);

		if (event.detail.text === 0) {
			domainAvailable = false;
			plans = false;
			search = true;
			back = true;
			await tick();
			back = false;
		} else {
			domainAvailable = true;
			plans = true;
			search = false;
		}
	}

	console.log("handle", handleBack);
</script>

<svelte:head>
	<script src="https://js.stripe.com/v3/"></script>
</svelte:head>

<div id="domain-result">
	{#if ready}
		<!-- <Slide slide={preuser} {back}></Slide> -->

		<div class="tabs">
			<Tabs
				on:tabchange={tabChange}
				{tabs}
				tabVal={curtab}
				useStore={true}
			/>
		</div>
		<SelectDomain on:domainchecked={domainChecked} {domainAvailable} {api}
		></SelectDomain>

		{#if domainAvailable}
			<ChoosePlan on:planset={planSet} {api}></ChoosePlan>
		{/if}
		<!-- {#if ready && $objectStore.available && $objectStore.plan} -->
		<!-- <Modal {showModal} closeModal={handleBack}> -->
		<!-- <Login {api} {token}></Login> -->

		<!-- <Modal {showModal} closeModal={handleBack}> -->

		<!-- <User {api} {token} on:back={handleBack}></User> -->
		{#if showModal}
			<User {api} {token} on:back={handleBack} />
		{/if}
		<!-- <User {api} {token} on:back={handleBack}></User> -->
		<!-- </Modal> -->
		<!-- {/if} -->

		<!-- <User {api} {token} on:back={handleBack}></User> -->
		<!-- <Slide slide={search} {back}> -->
		<!-- </Slide> -->

		<!-- <Slide slide={plans} {back}> -->
		<!-- </Slide> -->

		<!-- <Slide slide={user} {back}> -->
		<!-- </Slide> -->
	{/if}
</div>

<style>
	@import url("https://fonts.googleapis.com/css2?family=Ubuntu:ital,wght@0,300;0,400;0,500;0,700;1,300;1,400;1,500;1,700&display=swap");
	:root {
		/* --default-color: #007AFF; */
		--default-color: #007aff !important;
		width: 100vw;
	}

	#domain-result {
		position: relative;
		width: 100%;
		max-width: 600px;
		text-align: center;
		min-height: 100%;
		margin: auto;
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.tabs {
		width: 280px;
		/* height: 10px; */
		/* padding-top: 20px; */
		margin: auto;
	}
	:global(.content) {
		position: relative;
		text-align: center;
		width: calc(100% - 60px);
		margin: auto;
	}
	:global(button.btn-svelte) {
		/* margin-top: 10px; */
		display: block;
		width: 100%;
		max-width: 600px;
		height: 60px;
		/* margin-top: 30px; */
		margin-bottom: 15px;
		color: #fff;
		/* background: #007AFF; */
		background: #000000;
		border: none;
		font-weight: 600;
		font-size: 18px;
		border-radius: 10px;
		outline: none;
		-webkit-tap-highlight-color: transparent;
		user-select: none;
		cursor: pointer;
	}
	:global(button:focus, button:active) {
		/* background-color: #007AFF; */
		background-color: #000000;
		color: #fff;
	}

	:global(.ripple) {
		background-position: center;
		transition: background 0.8s;
	}
	/* :global(.ripple:hover) {
		background: rgb(0, 0, 0, 1)
			radial-gradient(circle, rgba(0, 0, 0, 1) 1%, #007aff 1%)
			center/15000%;
		/* background-color: #000000; */
	/* }  */

	:global(.ripple:hover) {
		background-color: rgb(0, 0, 0); /* Definir el color de fondo */
		background-image: radial-gradient(
			circle,
			rgba(0, 0, 0, 1) 1%,
			#007aff 1%
		);
		background-position: center;
		background-size: 15000%;
		transition: background 0.8s;
	}

	:global(.ripple:active) {
		background-color: transparent;
		background-size: 100%;
		transition: background 0s;
	}

	:global(h1) {
		letter-spacing: -2px;
		margin: 20 auto;
		width: 100%;
		max-width: 600px;
		text-align: left;
		box-sizing: border-box;
		padding-top: 30px;
		font-size: 38px;
	}

	:global(h3) {
		margin: 0 auto;
		width: 100%;
		max-width: 600px;
		text-align: left;
		box-sizing: border-box;
		color: rgba(1, 1, 1, 0.4);
		font-weight: 400px;
		font-weight: 400;
		font-size: 16px;
		margin-bottom: 30px !important;
	}

	:global(form input) {
		height: 50px;
		background-color: white;
		border-radius: 10px;
		margin: 5px auto;
		width: 100%;
		max-width: 600px;
		border: none;
		padding: 15px;
		font-size: 15px;
		font-weight: 400;
		user-select: none;
		outline: none;
		box-sizing: border-box;
		box-shadow:
			0 0 0 1px #e0e0e0,
			0 2px 4px 0 rgba(0, 0, 0, 0.07),
			0 1px 1.5px 0 rgba(0, 0, 0, 0.05);
		transition:
			box-shadow 0.08s ease-in,
			color 0.08s ease-in;
		-webkit-tap-highlight-color: transparent;
		-webkit-appearance: none;
		appearance: none;
		overflow: visible;
	}

	:global(form input::placeholder) {
		color: #666;
	}

	:global(input:focus, input:active) {
		background-color: white;
		box-shadow:
			0 0 0 1px rgba(50, 151, 211, 0.3),
			0 1px 1px 0 rgba(0, 0, 0, 0.07),
			0 0 0 4px rgba(50, 151, 211, 0.3);
	}
	:global(input.good) {
		background-color: white;
		box-shadow:
			0 0 0 1px #e0e0e0,
			0 2px 4px 0 rgba(0, 0, 0, 0.07),
			0 1px 1.5px 0 rgba(0, 0, 0, 0.05);
		transition:
			box-shadow 0.08s ease-in,
			color 0.08s ease-in;
	}
	:global(input.error) {
		background-color: #fffbfb;
		color: #d40000;
	}
	:global(button.good) {
		background-color: #000;
	}
	:global(button.disabled) {
		background-color: rgba(1, 1, 1, 0.1) !important;
	}
	:global(a) {
		text-decoration: none;
		color: #007aff;
		font-size: 14px;
		cursor: pointer;
		-webkit-tap-highlight-color: transparent;
		outline: none;
	}
</style>
